const module = [
    { iconfont: 'icon-menzhenguahao', iconfontColor: '#345DF5', path: 'appointStep1' , moduleName: '专家预约'},
    { iconfont: '', iconfontColor: '#694B4B', path: 'appointView', moduleName: '专家预约记录' },
    { iconfont: '', iconfontColor: '#6B400D', path: 'pavilionAppoint', moduleName: '面试亭' },
    { iconfont: 'icon-rengongzhinengjiejuefanganicon', iconfontColor: '#A52A2A', path: 'aiConsult', moduleName: 'AI咨询' },
  ];


export function getConsultModule(consult_SmartPavilion ) {
   if(typeof consult_SmartPavilion  !== 'number' || consult_SmartPavilion < 1 || consult_SmartPavilion > 3) {
    throw new Error('401');
   }
    let getFilteredData = [];
  
    switch (consult_SmartPavilion ) {
      case 1:
        getFilteredData = [module[3]]; 
        break;
      case 2:
        getFilteredData = [module[0], module[1], module[3]]; 
        break;
       
      case 3:
        getFilteredData = module; 
        break;

      default:
        getFilteredData = []
        console.warn('未定义的变量值:', consult_SmartPavilion );
        break;
    }
  
    return getFilteredData;
  }
